var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tippy-tooltip",
    {
      staticClass: "share-popup",
      attrs: {
        placement: "right",
        trigger: _vm.getEventForDevice,
        "append-to": "parent",
        interactive: true,
        theme: "light",
      },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function () {
            return [
              _c("z-icon", {
                attrs: { name: _vm.iconName, width: "32", height: "32" },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("z-share", {
        attrs: {
          services: ["vkontakte", "twitter"],
          lang: _vm.$root.lang,
          bare: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }